import { CONT_COORD, CONT_HOME_ADMIN, CONT_LIST, CONT_LIST_ADMIN, CONT_NBREAD, CONT_NBREAD_ADMIN, CONT_SEND, CONT_SEND_ADMIN, NEWS_NB, NEWS_SAVE, NEWS_SEND } from "../actions/action-types";
import { initalState, initialStateDatasArray, initialStateNext } from "../helpers";

// Envoyer un message
export function SendMessageReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CONT_SEND:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Sauvegarder les coordonnées
export function SaveCoordMessageReducer(state = initalState, action) {
    switch (action.type) {
        case CONT_COORD:
            return {
                alert: action.payload.alert
            }
        default:
            return {
                alert: state.alert
            };
    }
}

// Envoyer un message (admin)
export function SendMessageAdminReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CONT_SEND_ADMIN:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Liste des messages
export function ListMessageReducer(state = initialStateDatasArray, action)  {
    switch (action.type) {
        case CONT_LIST:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Liste des messages (admin)
export function ListMessageAdminReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case CONT_LIST_ADMIN:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Liste des messages (admin accueil)
export function ListMessageAdminHomeReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case CONT_HOME_ADMIN:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Nombre de message non lu (user)
export function NbMessageNoReadReducer(state = initalState, action) {
    switch (action.type) {
        case CONT_NBREAD:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return {
                alert: state.alert,
                datas: 0
            }
    }
}

// Nombre de message non lu admin (user)
export function NbMessageNoReadAdminReducer(state = initalState, action) {
    switch (action.type) {
        case CONT_NBREAD_ADMIN:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return {
                alert: state.alert,
                datas: 0
            }
    }
}

// Sauvegarder newsletter
export function SaveNewsReducer(state = initalState, action) {
    switch (action.type) {
        case NEWS_SAVE:
            return {
                alert: action.payload.alert
            }
        default:
            return {
                alert: state.alert
            };
    }
}

// Envoyer newsletter
export function SendNewsReducer(state = initalState, action) {
    switch (action.type) {
        case NEWS_SEND:
            return {
                alert: action.payload.alert
            }
        default:
            return {
                alert: state.alert
            };
    }
}

// Obtenir le nombre de personnes présentes dans la newsletter
export function NbUserNewsletterReducer(state = initalState, action) {
    switch (action.type) {
        case NEWS_NB:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return {
                alert: state.alert,
                datas: 0
            }
    }
}